import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../shared/authorization/authorization.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: [
    './../shared/user.scss',
    './maintenance.component.scss'
  ],
})
export class MaintenanceComponent implements OnInit {

  constructor(
    private authorizationService: AuthorizationService,
    private router: Router
  ) { }

  async ngOnInit() {
    var inMaintenance = await this.authorizationService.inMaintenance().toPromise();
    if (!inMaintenance) {
      this.router.navigate(['/']);
    }
  }

}
